import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface RolePermissionsState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action:
  | "add"
  | "update"
  | "list"
  | "assign-permission"
  | "get-permission"
  | "assign-emp-permission"
  | "get-emp-permission"
  | null;
}

const initialState: RolePermissionsState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};


export const getEmpPermissions: any = createAsyncThunk(
  "fetch/emp-permissions",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.EMP_PERMISSION,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const assignEmpPermission: any = createAsyncThunk(
  "assign/emp-permission",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.ASSIGN_EMP_PERMISSION,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);




export const getPermissions: any = createAsyncThunk(
  "fetch/permissions",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.ROLES_PERMISSION,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const assignPermission: any = createAsyncThunk(
  "assign/permission",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.ASSIGN_PERMISSION,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const fetchAll: any = createAsyncThunk(
  "fetch/roles",
  async (payload: any, thunkAPI) => {
    try {
      const requestPayload = { ...payload };
      if (payload && (payload.roleName !== undefined || payload.query !== undefined)) {
        requestPayload.roleName = payload.roleName ?? payload.query;
      }
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.ROLES_LIST,
        requestPayload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const findAllDepartments: any = createAsyncThunk(
  "fetch/roles",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.FIND_ALL_DEPARTMENTS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const findAllDesignations: any = createAsyncThunk(
  "fetch/roles",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.FIND_ALL_DESIGNATIONS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const workSchedule: any = createAsyncThunk(
  "fetch/roles",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.WORK_SCHEDULE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const add: any = createAsyncThunk(
  "add/roles",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.ADD_NEW_ROLE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const update: any = createAsyncThunk(
  "update/roles",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ROLE_PERMISSIONS.UPDATE_ROLE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const roleSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(assignPermission.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "assign-permission";
    });
    builder.addCase(assignPermission.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "assign-permission";
    });
    builder.addCase(assignPermission.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "assign-permission";
    });

    builder.addCase(getPermissions.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "get-permission";
    });
    builder.addCase(getPermissions.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "get-permission";
    });
    builder.addCase(getPermissions.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "get-permission";
    });

    builder.addCase(fetchAll.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(fetchAll.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(fetchAll.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

    builder.addCase(add.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "add";
    });
    builder.addCase(add.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "add";
      state.error = null;
    });
    builder.addCase(add.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "add";
    });

    builder.addCase(update.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "update";
    });
    builder.addCase(update.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "update";
      state.error = null;
    });
    builder.addCase(update.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "update";
    });



    builder.addCase(getEmpPermissions.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "get-emp-permission";
    });
    builder.addCase(getEmpPermissions.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "get-emp-permission";
      state.error = null;
    });
    builder.addCase(getEmpPermissions.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "get-emp-permission";
    });


    builder.addCase(assignEmpPermission.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "assign-emp-permission";
    });
    builder.addCase(assignEmpPermission.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "assign-emp-permission";
      state.error = null;
    });
    builder.addCase(assignEmpPermission.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "assign-emp-permission";
    });




  },
});

export const { resetAll } = roleSlice.actions;
export default roleSlice.reducer;
